export default class ActiveMenuItem {
    init() {
            console.log("Hello");
            const tempPath = window.location.pathname;
            const currentPath = tempPath.slice(0, -1);
            console.log(currentPath);
            const menuItems = document.querySelectorAll('.menu-item-underline');
            menuItems.forEach((item) => {
                console.log(item.getAttribute('href'));
              if (item.getAttribute('href') === currentPath) {
                item.classList.add('active');
              } else {
                item.classList.remove('active');
              }
            });
    }
}